import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Menu } from 'semantic-ui-react';
import { MenuItemType } from '../../../../../lib/proptypes/menu.proptypes';
import { NavLink } from '../../../../../lib/components/link';
import lockIcon from '../../../../../assets/images/key-icon-small.svg';
import classes from './sidebar.css';
import styles from './SidebarLowerMenu.styles';

const AccordionContent = ({ children, key }) => (
  children && children.length
    ? <Accordion.Content
      style={styles.accordianContent}
      key={`${key}_Content`}
    >
      <Menu vertical style={styles.menu}>
        {children.map(
            childItem => (
              <NavLink
                {...childItem}
                style={styles.link}
                key={childItem.key}
                className="sidebarMenuItem"
                activeClassName="activeNav"
                exact
              >
                <span>{childItem.label}</span>
                {childItem.restricted && <img src={lockIcon} alt="Restricted access" />}
              </NavLink>
            ),
          )}
      </Menu>
    </Accordion.Content>
    : <Accordion.Content
      style={styles.emptyAccordianContent}
      key={`${key}_Content`}
    />);

AccordionContent.propTypes = {
  children: PropTypes.arrayOf(MenuItemType).isRequired,
  key: PropTypes.string.isRequired,
};

export default AccordionContent;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/NavAccordionContent.js